import * as Yup from 'yup';

const propertySubCategorySchema = Yup.object().shape({
  labelEn: Yup.string().required('Label En is required.'),
  labelAr: Yup.string().required('Label Ar is required.'),
  propertyCategoryId: Yup.string().required('Property Category is required.'),
  position: Yup.number()
    .min(0, "Please enter more than 0")
    .typeError("Must be Number"),
});

export default propertySubCategorySchema;